export const skipTracking = () => __DEV__ && !window.Cypress;
